export default "__VITE_PUBLIC_ASSET__afae4ede__"